<main class="bg-main-white w-100 w-100-mob">
  <app-heading></app-heading>
  <div class="text-center justify-content-center align-items-center d-flex">
    <div class="heading-mobile">
      <div class="pt-17 pt-16vw d-flex justify-content-center text-center">
        <div class="not-mobile-div fs-64px-lh-70px f-col fw-semibold ls-01em w-950px">
          Empower Your Assessments with AI-Driven
          <div class="bg-spec font-outfit rounded-3 d-inline-block">&nbsp;Quiz Creation&nbsp;</div>
        </div>
      </div>
      <div class="heading-custom-media mt-7 w-1240 text-start f-col fw-semibold ls-01em p-3">
        &nbsp;Empower Your &nbsp;Assessments with &nbsp;AI-Driven Quiz
        <div class="bg-spec font-outfit rounded-3 d-inline">&nbsp;Creation&nbsp;</div>
      </div>
      <div class="subheading d-flex justify-content-center align-items-center text-center">
        <div class="w-335px pb-3 pt-4 w-580px w-30 w-md-45 w-lg-40">
          <h3 class="fs-14-lh-21 lh-md fw-light col-grey font-outfit">
            Streamline test creation, track performance, and unlock the power of intelligent quizzes for unparalleled
            learning and development
          </h3>
        </div>
      </div>
      <div class="text-center text-left-mobile">
        <div class="ml-20px mt-2 mt-05vw d-inline-block">
          <button type="submit"
                  class="trial-style-p rounded-4 bg-purple border-0 h-48px ps-5 pe-5 g-3 pt-2 pt-0-6 d-flex align-items-center justify-content-center">
            <h4 class="f-col text-center fw-medium lh-3 ls-02em mb-1">
              Start&nbsp;Free&nbsp;Trial
            </h4>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="simplify-section mt-12 mt-6vw position-relative">
    <div class="m-0 m-0-mob p-0 w-100 w-100-mob d-flex justify-content-center">
      <div class="container container-mob not-mobile-div position-absolute d-inline-block m-0 p-0 w-390">
        <img src="/assets/images/background/simplify-background.png" alt="admin-background"
             class="admin-background-small z-1 rounded-3 w-100 w-100-mob d-flex">
      </div>
      <div class="mobile-back-div me-1rem ms-2rem d-inline-block position-absolute container container-mob w-390">
        <img src="/assets/images/background/mobile-background.png" alt="admin-background"
             class="mobile-background-small rounded-3 wh-mobile position-absolute d-flex"></div>
    </div>
    <div class="d-flex position-relative justify-content-center">
      <div class="assessment-div z-3 p-7 p-1rem mt-11 mt-30px w-600px-h-547px br-2px-black d-inline-block bg-white rounded-3 mr-480px">
        <div class="simplify-div fw-semibold f-col"><span class="fs-40-lh-48 ls-01em">Simplify<span
          class="simplify-spec-div rounded-3 bg-spec d-inline">&nbsp;Assessment&nbsp;</span>with Intelligent Quizzes</span>
        </div>
        <div class="our-platform mt-6 mt-6-custom">
          <h3 class="fs-14-lh-21 lh-2 col-grey font-outfit fw-light">Our platform combines powerful AI with an
            intuitive, user-friendly interface, making quiz creation easier than ever. Design custom quizzes, tailor
            questions, and access AI-generated suggestions in minutes. Perfect for educators, trainers, and
            institutions looking to streamline assessment with cutting-edge technology.</h3>
        </div>
        <div class="our-platform d-flex mb-3 pe-15 pe-15-mob mb-1vw mt-6 mt-6-custom">
          <img src="/assets/images/dot/dot.png" alt="dot" class="dot-icon mt-2 d-inline-block dot-mobile-m">
          <div class="dot-text-div ms-3 ms-3-mob d-inline-block align-middle">
            <h2 class="m-0 f-col fw-normal">AI-Powered quiz creation for faster setup</h2>
          </div>
        </div>
        <img src="/assets/images/dot/dot.png" alt="dot" class="dot-icon mt-2 d-inline-block">
        <div class="dot-text-div ms-3 ms-3-mob d-inline-block align-middle mt-2 mt-05vw">
          <h2 class="f-col m-0 fw-normal">Real-time progress tracking</h2>
        </div>
      </div>
      <div class="not-mobile-div container container-mob position-absolute d-flex justify-content-end m-0 p-0">
        <img src="/assets/images/background/avatar-background.png" alt="avatar-background" class="avatar-background z-4">
      </div>
      <div class="mobile-back-div position-absolute d-flex justify-content-end avatar-div">
        <img src="/assets/images/background/avatar-background.png" alt="avatar-background"
             class="avatar-background mobile-back-div">
      </div>
    </div>
  </div>
  <div class="justify-content-center d-flex mt-10 mt-5vw">
    <div id="for-every-need" class="every-need mt-15 mt-8vw mt-12-mob pt-12 pt-6vw gap-5 gap-5-mob d-flex pb-0 bg-white rounded-3 container container-mob">
      <div class="w-472px me-3 me-1vw mt-3 mt-1vw ms-12 ms-5vw text-nowrap">
        <div class="every-need-span mb-1rem lh-1 ls-01em f-col fw-semibold">
          Designed for<br>Every
          <div class="rounded-3 bg-spec d-inline-block">&nbsp;Need&nbsp;</div>
        </div>
        <div class="not-mobile-div">
          <h3 class="platform-text mt-4 col-grey lh-2 font-outfit fw-light">Our platform serves diverse educational and training<br>contexts,
            each tailored for unique goals and users.</h3>
        </div>
        <div class="platform-text mobile-back-div">
          <h3 class="col-grey fs-16-lh-0 lh-2 font-outfit fw-light">Our platform serves diverse educational and training
            contexts, each tailored for unique goals and users.</h3>
        </div>
      </div>
      <img src="/assets/images/every-need/devider.png" alt="devider" class="devider-img">
      <img src="/assets/images/every-need/devider-horizontal.png" alt="devider"
           class="devider-horizontal d-inline-block">
      <div class="mt-3 mt-50px ml-20px">
        <div>
          <img src="/assets/images/every-need/school-icon.png" alt="school" class="school-icon ms-1">
        </div>
        <div class="university-text-div pt-5 pt-1vw">
          <h2 class="lh-2 f-col ls-01em fw-bold mb-0">
            Universities & Colleges</h2></div>
        <div class="university-div w-442px mb-10">
          <h3 class="university-p lh-2 col-grey fw-light f-col">
            Empower instructors with adaptable tools that address varied learning needs.</h3>
        </div>
        <div class="g-20 mb-12">
          <div>
            <img src="/assets/images/every-need/history-edu.png" alt="education" class="history-edu ms-1">
          </div>
          <div class="university-text-div pt-5 pt-1vw">
            <h2 class="lh-2 f-col ls-01em fw-bold mb-0">
              Training Institutes</h2>
          </div>
          <div class="university-div w-442px">
            <h3 class="university-p lh-2 col-grey f-col fw-light">
              Optimize skills retention and knowledge evaluation with streamlined assessments.</h3>
          </div>
        </div>
        <div class="corporate-training g-20">
          <img src="/assets/images/every-need/corporate-training.png" alt="corporate-training"
               class="corporate-training-img">
          <div class="corporate-training-div">
            <h2 class="lh-2 f-col ls-01em fw-bold mb-0">Corporate Training</h2></div>
          <div class="university-div">
            <h3 class="university-p lh-2 col-grey f-col">Track and measure employee growth with structured quizzes and
              analytics.</h3>
          </div>
        </div>
        <div class="independent-educators g-20">
          <img src="/assets/images/every-need/independent-educators.png" alt="independent-educators"
               class="corporate-training-img">
          <div class="corporate-training-div">
            <h2 class="lh-2 f-col ls-01em fw-bold mb-0">Independent Educators</h2></div>
          <div class="university-div">
            <span class="university-p fs-20-lh-30-mobile col-grey f-col">Simplify the process of reaching learners and customizing assessments, wherever you are.</span>
          </div>
        </div>
        <div class="not-mobile-div">
          <img src="/assets/images/every-need/rectangle.png" alt="rectangle" class="rectangle mt-3 ms-3 ms-3-mob">
        </div>
      </div>
    </div>
  </div>
  <div class="justify-content-center d-flex">
    <div class="mt-14 mt-7vw gap-3 gap-sm-3 gap-md-5 gap-lg-7 d-flex">
      <div class="d-flex position-relative rounded-3">
        <img src="/assets/images/background/highlight-background.png" alt="highlight-background"
             class="highlight-background">
        <div class="quiz-creation d-flex position-absolute justify-content-center align-items-center text-center">
          <img src="/assets/images/background/ai-powered-creation.png" alt="highlight-background"
               class="w-520px mt-8 mt-4-mob ms-12 ms-5vw ms-6-2" *ngIf="isQuizCreationVisible">
          <img src="/assets/images/background/real-time-progress.png" alt="highlight-background"
               class="w-553px mt-7 ms-3 ms-3-mob ms-1-2" *ngIf="isRealTimeProgressVisible">
          <img src="/assets/images/background/optimized-devices.png" alt="highlight-background"
               class="w-506px mt-11 mt-30px mt-6-1 ms-8 ms-4-3" *ngIf="isOptimizedDevicesVisible">
        </div>
      </div>
      <div>
        <img src="/assets/images/dot/hr-custom.png" alt="hr" class="hr-custom">
        <div class="ai-powered-quiz-creation p-5 p-1rem-important bg-white rounded-4 position-relative" *ngIf="isQuizCreationVisible">
          <img src="/assets/images/dot/rounded-minus.png" alt="minus" class="rounded-minus position-absolute">
          <div class="ai-powered-first-div ms-6 ms-3-2 d-inline-block align-middle fw-light">
            <h2 class="lh-2 f-col fw-bold ls-01em mb-0 pb-0">AI-Powered Quiz Creation</h2>
          </div>
          <div class="ai-powered-first-div ms-6 ms-3-2 d-inline-block align-middle fw-light">
            <div class="pt-2">
              <h3 class="lh-2 font-outfit fw-light col-grey">
                Automate and streamline quiz building with intelligent suggestions, question banks, and adaptive formats
                that fit your style.
              </h3>
            </div>
          </div>
        </div>
        <div class="ai-powered-quiz-creation-plus p-5 p-1rem-important g-20" *ngIf="!isQuizCreationVisible"
             (click)="toggleSection('quizCreation')">
          <img src="/assets/images/dot/rounded-plus.png" alt="plus" class="rounded-plus position-absolute">
          <div class="ai-powered-first-div ms-6 ms-3-2 d-inline-block align-middle fw-light">
            <h2 class="lh-2 f-col fw-bold ls-01em mb-0 pb-0">AI-Powered Quiz Creation</h2>
          </div>
        </div>
        <img src="/assets/images/dot/hr-custom.png" alt="hr" class="hr-custom">
        <div class="ai-powered-quiz-creation-plus p-5 p-1rem-important g-20" *ngIf="!isRealTimeProgressVisible"
             (click)="toggleSection('realTimeProgress')">
          <img src="/assets/images/dot/rounded-plus.png" alt="plus" class="rounded-plus position-absolute">
          <div class="ai-powered-first-div ms-6 ms-3-2 d-inline-block align-middle fw-light">
            <h2 class="lh-2 f-col fw-bold ls-01em mb-0 pb-0">Real-Time Progress Tracking</h2>
          </div>
        </div>
        <div class="ai-powered-quiz-creation p-5 p-1rem-important bg-white g-20 rounded-4" *ngIf="isRealTimeProgressVisible">
          <img src="/assets/images/dot/rounded-minus.png" alt="minus" class="rounded-minus position-absolute">
          <div class="ai-powered-first-div ms-6 ms-3-2 d-inline-block align-middle fw-light">
            <h2 class="lh-2 f-col fw-bold ls-01em mb-0 pb-0">Real-Time Progress Tracking</h2>
          </div>
          <div class="ai-powered-first-div ms-6 ms-3-2 d-inline-block align-middle fw-light">
            <div class="pt-2">
              <h3 class="lh-2 font-outfit fw-light col-grey">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua.
              </h3>
            </div>
          </div>
        </div>
        <img src="/assets/images/dot/hr-custom.png" alt="hr" class="hr-custom">
        <div class="ai-powered-quiz-creation p-5 p-1rem-important bg-white g-20 rounded-4" *ngIf="isOptimizedDevicesVisible">
          <img src="/assets/images/dot/rounded-minus.png" alt="minus" class="rounded-minus position-absolute">
          <div class="ai-powered-first-div ms-6 ms-3-2 d-inline-block align-middle fw-light">
            <h2 class="lh-2 f-col fw-bold ls-01em mb-0 pb-0">Optimized for All Devices</h2>
          </div>
          <div class="ai-powered-first-div ms-6 ms-3-2 d-inline-block align-middle fw-light">
            <div class="pt-2">
              <h3 class="lh-2 font-outfit fw-light col-grey">Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</h3>
            </div>
          </div>
        </div>
        <div class="ai-powered-quiz-creation-plus p-5 p-1rem-important g-20" *ngIf="!isOptimizedDevicesVisible"
             (click)="toggleSection('optimizedDevices')">
          <img src="/assets/images/dot/rounded-plus.png" alt="plus" class="rounded-plus position-absolute">
          <div class="ai-powered-first-div ms-6 ms-3-2 d-inline-block align-middle fw-light">
            <h2 class="lh-2 f-col fw-bold ls-01em mb-0 pb-0">Optimized for All Devices</h2>
          </div>
        </div>
        <img src="/assets/images/dot/hr-custom.png" alt="hr" class="hr-custom">
      </div>
    </div>
  </div>
  <div class="justify-content-center d-flex">
    <div class="features-highlight-mobile">
      <div class="position-relative">
        <img src="/assets/images/dot/hr-custom.png" alt="hr" class="hr-mobile">
        <div class="ai-powered-quiz-creation-mobile bg-white g-20" *ngIf="isQuizCreationVisible">
          <div class="d-inline-block">
            <img src="/assets/images/dot/rounded-minus.png" alt="minus" class="rounded-minus mb-22">
          </div>
          <div class="ai-powered-first-div ms-6 ms-3-2 d-inline-block fw-light">
            <h2 class="lh-2 f-col fw-bold mb-4 mb-025rem">AI-Powered Quiz Creation</h2>
            <div class="pt-2 pt-0-6">
              <h5 class="lh-2 font-outfit col-grey fw-normal">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua.
              </h5>
            </div>
          </div>
        </div>
        <img src="/assets/images/background/ai-powered-mobile.png" alt="ai-powered-quiz" class="ai-powered-quiz"
             *ngIf="isQuizCreationVisible">
        <div class="ps-4 pe-4 pr-0 mt-5 mt-1rem g-20" *ngIf="!isQuizCreationVisible"
             (click)="toggleSection('quizCreation')">
          <div class="d-inline-block">
            <img src="/assets/images/dot/rounded-plus.png" alt="plus" class="rounded-plus-mobile">
          </div>
          <div class="ai-powered-first-div ms-6 ms-3-2 d-inline-block align-middle fw-light">
            <h2 class="lh-2 f-col fw-bold ls-01em mb-2">AI-Powered Quiz Creation</h2>
          </div>
        </div>
        <div class="hr-mobile-div d-inline-block mt-4" *ngIf="!isQuizCreationVisible">
          <img src="/assets/images/dot/hr-custom.png" alt="hr" class="hr-mobile">
        </div>
        <div class="hr-mobile-div t-hr-94 d-inline-block" *ngIf="!isRealTimeProgressVisible && isQuizCreationVisible">
          <img src="/assets/images/dot/hr-custom.png" alt="hr" class="hr-mobile">
        </div>
        <div class="ps-4 ps-0-important pe-4 pe-4rem pe-2rem hr-mobile-div t-hr-105 g-20 d-flex align-items-center" *ngIf="!isRealTimeProgressVisible"
             [ngClass]="!isQuizCreationVisible ? 'mt-12' : ''"
             (click)="toggleSection('realTimeProgress')">
          <img src="/assets/images/dot/rounded-plus.png" alt="plus" class="rounded-plus-mobile">
          <div class="ai-powered-first-div ms-6 ms-3-2 align-middle fw-light">
            <h2 class="lh-2 f-col fw-bold ls-01em d-inline-block mb-2">Real-Time Progress Tracking</h2>
          </div>
        </div>
        <div class="real-time-progress-mobile bg-white g-20" *ngIf="isRealTimeProgressVisible">
          <img src="/assets/images/dot/rounded-minus.png" alt="minus" class="rounded-minus-mobile mb-14 mb-7rem">
          <div class="ai-powered-first-div ms-6 ms-3-2 d-inline-block align-middle fw-light">
            <h2 class="lh-2 f-col fw-bold ls-01em mb-2">Real-Time Progress Tracking</h2>
            <div class="ai-powered-first-text d-inline-block align-middle">
              <div class="pt-2 pt-0-6">
                <h5 class="lh-2 font-outfit col-grey fw-normal">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                  dolore magna aliqua.
                </h5>
              </div>
            </div>
          </div>
        </div>
        <img src="/assets/images/background/real-time-progress-mobile.png" alt="real-time-progress"
             class="ai-powered-quiz" *ngIf="isRealTimeProgressVisible">
        <div class="hr-mobile-div t-hr-101" *ngIf="isRealTimeProgressVisible">
          <img src="/assets/images/dot/hr-custom.png" alt="hr" class="hr-mobile">
        </div>
        <div class="hr-mobile-div"
             [ngClass]="isQuizCreationVisible ? 'mt-12' : 'mt-20'" *ngIf="!isRealTimeProgressVisible">
          <img src="/assets/images/dot/hr-custom.png" alt="hr" class="hr-mobile">
        </div>
      </div>
      <div class="optimized-devices-mobile position-absolute bg-white g-20 mt-21" *ngIf="isOptimizedDevicesVisible">
        <div class="p-4 p-3-important">
          <div class="d-inline-block">
            <img src="/assets/images/dot/rounded-minus.png" alt="minus" class="rounded-minus-mobile mb-14 mb-7rem">
          </div>
          <div class="ai-powered-first-div ms-6 ms-3-2 d-inline-block align-middle fw-light">
            <h2 class="lh-2 f-col fw-bold ls-01em mb-2">Optimized for All Devices</h2>
            <div class="ai-powered-first-text d-inline-block align-middle">
              <div class="pt-2 pt-0-6">
                <h5 class="lh-2 font-outfit col-grey fw-normal">Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                  sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</h5>
              </div>
            </div>
          </div>
        </div>
        <img src="/assets/images/background/optimized-devices-mobile.png" alt="optimized-devices"
             class="ai-powered-quiz" *ngIf="isOptimizedDevicesVisible">
      </div>
      <div class="hr-mobile-div mt-685px" *ngIf="isOptimizedDevicesVisible">
        <img src="/assets/images/dot/hr-custom.png" alt="hr" class="hr-mobile">
      </div>
      <div class="ps-4 pe-4 g-20 d-flex align-items-center"
           [ngClass]="isRealTimeProgressVisible ? 'mt-7' : 'mt-18'"
           *ngIf="!isOptimizedDevicesVisible"
           (click)="toggleSection('optimizedDevices')">
        <img src="/assets/images/dot/rounded-plus.png" alt="plus" class="rounded-plus-mobile">
        <div class="ai-powered-first-div ms-6 ms-3-2 d-inline-block align-middle fw-light">
          <h2 class="lh-2 f-col fw-bold ls-01em mb-2">Optimized for All Devices</h2>
        </div>
      </div>
      <div class="hr-mobile-div mt-5 mt-1rem"
           *ngIf="!isOptimizedDevicesVisible">
        <img src="/assets/images/dot/hr-custom.png" alt="hr" class="hr-mobile">
      </div>
    </div>
  </div>
  <div class="bg-white br-1px-white mt-100px">
    <div id="fit-needs"
         [ngClass]="{
            'mb-2580': subscriptionPlanLength === 4,
            'mb-2025': subscriptionPlanLength === 3,
            'mb-1450': subscriptionPlanLength === 2
       }"
         class="fit-needs pt-13 pb-13 mt-13 position-relative flex-column d-flex justify-content-center align-items-center">
      <div class="w-100 w-100-mob flex-column justify-content-center align-items-center d-flex">
        <div class="pt-6rem fit-needs-div position-relative d-inline-block text-center w-503px">
          <span class="fs-40-lh-48 f-col fw-semibold ls-01em">Choose<span class="bg-spec rounded-3">&nbsp;the Plan&nbsp;</span>That Fits Your Needs</span>
        </div>
        <div class="fits-needs-subheader-div mt-3 mt-1vw text-center w-698px">
          <h3 class="fw-400 lh-2 col-grey font-outfit fw-light">Explore our subscription options tailored to a wide
            range
            of educational and training needs. Start with a risk-free Free Trial to discover how IT Quiz can
            revolutionize
            your assessment process.</h3>
        </div>
        <div class="m-6 m-0-important">
          <app-quiz-binary-toggle
            [leftLabel]="'Monthly'"
            [rightLabel]="'Annually'"
            [(isLeftSelected)]="isChecked"
          ></app-quiz-binary-toggle>
        </div>
        <div [ngClass]="{
        'pb-7': subscriptionPlanLength === 2
        }"
          class="container container-mob m-0 p-0 bg-fit-purple h-auto z-index-0 position-relative text-center d-inline-block rounded-3 gap-4">
          <img src="/assets/images/background/smaller-background.png" alt="admin-background"
               class="background-fit-small z-1 h-100 rounded-3 w-100 w-100-mob d-flex position-absolute">
          <div class="col z-index-70 position-relative fit-column-section z-2 rounded-3 pt-5 pe-5 ps-5 pb-6 d-inline-block mt-80px-mb-28px"
               [ngClass]="{
            'me-2 w-282px': subscriptionPlanLength === 4,
            'w-344px': subscriptionPlanLength === 3,
            'me-4-2 w-528px': subscriptionPlanLength === 2
           }">
            <h2 class="lh-3 f-col fw-bold ls-01em mb-0">Basic</h2>
            <div class="pt-2 pt-0-6"
                 [ngClass]="{
              'w-222': subscriptionPlanLength === 4,
              'w-284': subscriptionPlanLength === 3,
              'w-468': subscriptionPlanLength === 2
              }">
              <h4 class="fw-normal col-grey font-outfit m-0">Ideal for small classrooms and individual educators</h4>
            </div>
            <h3 class="pt-3 f-col fw-medium lh-3 ls-02em mb-0">
              <span class="fs-40-lh-48-mobile ls-01em fw-semibold">$29</span> / per month
            </h3>
            <img src="/assets/images/dot/hr-custom.png" alt="hr" class="mt-5 mt-5-custom"
                 [ngClass]="{
              'w-222': subscriptionPlanLength === 4,
              'w-284': subscriptionPlanLength === 3,
              'w-468': subscriptionPlanLength === 2
              }">
            <div class="ms-1 pt-4">
              <img src="/assets/images/dot/blue-tick.png" alt="tick" class="blue-tick">
              <div class="align-middle d-inline-block">
                <h4 class="ms-2 f-col fw-normal mb-0">Plan Feature</h4></div>
              <br>
              <div class="h-10"></div>
              <img src="/assets/images/dot/close.png" alt="close" class="close">
              <div class="align-middle d-inline-block">
                <h4 class="ms-2 fw-normal f-col mb-0">Plan Feature</h4></div>
              <br>
              <div class="h-10"></div>
              <img src="/assets/images/dot/close.png" alt="close" class="close">
              <div class="align-middle d-inline-block">
                <h4 class="ms-2 fw-normal f-col mb-0">Plan Feature</h4></div>
              <br>
              <div class="h-10"></div>
              <img src="/assets/images/dot/close.png" alt="close" class="close">
              <div class="align-middle d-inline-block">
                <h4 class="ms-2 fw-normal f-col mb-0">Plan Feature</h4></div>
            </div>
            <button type="submit"
                    class="start-14-days rounded-4 pt-1 ls-02em bg-purple border-0 column-btn g-4 mt-6 mt-6-custom mt-3-1 d-flex align-items-center justify-content-center"
                    [ngClass]="{
                  'w-222': subscriptionPlanLength === 4,
                  'w-284': subscriptionPlanLength === 3,
                  'w-468': subscriptionPlanLength === 2
                }">
              <h4 class="mb-1 f-col text-center fw-medium">
                Start&nbsp;14&nbsp;Days&nbsp;for&nbsp;Free
              </h4>
            </button>
          </div>
          <div
            class="col z-index-70 position-relative fit-column-section z-2 rounded-3 pt-1rem d-inline-block br-2px-black m-0"
            [ngClass]="{
            'mb-4 me-2 w-282px': subscriptionPlanLength === 4,
            'mt-80px-mb-28px ms-4 me-4 w-344px': subscriptionPlanLength === 3,
            'mt-80px-mb-28px me-4-md w-528px': subscriptionPlanLength === 2
           }">
            <h2 class="f-col d-inline-block ms-3 ms-3-mob rounded-3 bg-spec fw-bold ls-01em">
              &nbsp;&nbsp;&nbsp;Pro&nbsp;&nbsp;&nbsp;</h2>
            <div class="pe-5 ps-5 pb-6">
              <div class="pt-2 pt-0-6"
                   [ngClass]="{
                'w-222': subscriptionPlanLength === 4,
                'w-284': subscriptionPlanLength === 3,
                'w-468': subscriptionPlanLength === 2
                }">
                <h4 class="fw-normal col-grey font-outfit m-0">Perfect for institutions with advanced needs</h4>
              </div>
              <h3 class="pt-3 f-col fw-medium lh-3 ls-02em mb-0">
                <span class="fs-40-lh-48-mobile ls-01em fw-semibold">$29</span> / per month
              </h3>
              <img src="/assets/images/dot/hr-custom.png" alt="hr" class="mt-5 mt-5-custom"
                   [ngClass]="{
                'w-222': subscriptionPlanLength === 4,
                'w-284': subscriptionPlanLength === 3,
                'w-468': subscriptionPlanLength === 2
                }">
              <div class="pt-4 ms-1">
                <img src="/assets/images/dot/blue-tick.png" alt="tick" class="blue-tick">
                <div class="align-middle d-inline-block">
                  <h4 class="ms-2 f-col fw-normal mb-0">Plan Feature</h4></div>
                <br>
                <div class="h-10"></div>
                <img src="/assets/images/dot/blue-tick.png" alt="tick" class="blue-tick">
                <div class="align-middle d-inline-block">
                  <h4 class="ms-2 fw-normal f-col mb-0">Plan Feature</h4></div>
                <br>
                <div class="h-10"></div>
                <img src="/assets/images/dot/close.png" alt="close" class="close" *ngIf="subscriptionPlanLength !== 2">
                <img src="/assets/images/dot/blue-tick.png" alt="tick" class="blue-tick"
                     *ngIf="subscriptionPlanLength === 2">
                <div class="align-middle d-inline-block">
                  <h4 class="ms-2 fw-normal f-col mb-0">Plan Feature</h4></div>
                <br>
                <div class="h-10"></div>
                <img src="/assets/images/dot/close.png" alt="close" class="close" *ngIf="subscriptionPlanLength !== 2">
                <img src="/assets/images/dot/blue-tick.png" alt="tick" class="blue-tick"
                     *ngIf="subscriptionPlanLength === 2">
                <div class="align-middle d-inline-block">
                  <h4 class="ms-2 fw-normal f-col mb-0">Plan Feature</h4></div>
              </div>
              <button type="submit"
                      class="start-14-days rounded-4 pt-1 bg-purple border-0 column-btn g-4 mt-6 mt-6-custom mt-3-1 d-flex align-items-center justify-content-center"
                      [ngClass]="{
                    'w-222': subscriptionPlanLength === 4,
                    'w-284': subscriptionPlanLength === 3,
                    'w-468': subscriptionPlanLength === 2
                  }">
                <h4 class="f-col text-center fw-medium ls-02em mb-1">
                  Start&nbsp;14&nbsp;Days&nbsp;for&nbsp;Free
                </h4>
              </button>
            </div>
          </div>
          <div class="col z-index-70 position-relative fit-column-section z-2 rounded-3 pt-5 pe-5 ps-5 pb-6 d-inline-block"
               *ngIf="subscriptionPlanLength === 4 || subscriptionPlanLength === 3"
               [ngClass]="{
            'mb-4 w-282px': subscriptionPlanLength === 4,
            'mb-11 w-344px': subscriptionPlanLength === 3
           }">
            <h2 class="lh-3 f-col fw-bold ls-01em mb-0">Enterprise</h2>
            <div class="pt-2 pt-0-6"
                 [ngClass]="{
              'w-222': subscriptionPlanLength === 4,
              'w-284': subscriptionPlanLength === 3
              }">
              <h4 class="fw-normal col-grey font-outfit m-0">Customizable options for large-scale implementations</h4>
            </div>
            <h3 class="pt-3 f-col fw-medium lh-3 ls-02em mb-0">
              <span class="fs-40-lh-48-mobile ls-01em fw-semibold">$29</span> / per month
            </h3>
            <img src="/assets/images/dot/hr-custom.png" alt="hr" class="mt-5 mt-5-custom"
                 [ngClass]="{
              'w-222': subscriptionPlanLength === 4,
              'w-284': subscriptionPlanLength === 3
              }">
            <div class="pt-4 ms-1">
              <img src="/assets/images/dot/blue-tick.png" alt="tick" class="blue-tick">
              <div class="align-middle d-inline-block">
                <h4 class="ms-2 f-col fw-normal mb-0">Plan Feature</h4></div>
              <br>
              <div class="h-10"></div>
              <img src="/assets/images/dot/blue-tick.png" alt="tick" class="blue-tick">
              <div class="align-middle d-inline-block">
                <h4 class="ms-2 fw-normal f-col mb-0">Plan Feature</h4></div>
              <br>
              <div class="h-10"></div>
              <img src="/assets/images/dot/blue-tick.png" alt="tick" class="blue-tick">
              <div class="align-middle d-inline-block">
                <h4 class="ms-2 fw-normal f-col mb-0">Plan Feature</h4></div>
              <br>
              <div class="h-10"></div>
              <img src="/assets/images/dot/blue-tick.png" alt="tick" class="blue-tick"
                   *ngIf="subscriptionPlanLength !== 4">
              <img src="/assets/images/dot/close.png" alt="close" class="close" *ngIf="subscriptionPlanLength === 4">
              <div class="align-middle d-inline-block">
                <h4 class="ms-2 fw-normal f-col mb-0">Plan Feature</h4></div>
            </div>
            <button type="submit"
                    class="start-14-days rounded-4 pt-1 bg-purple border-0 column-btn g-4 mt-6 mt-6-custom mt-3-1 d-flex align-items-center justify-content-center"
                    [ngClass]="{
                  'w-222': subscriptionPlanLength === 4,
                  'w-284': subscriptionPlanLength === 3
                }">
              <h4 class="f-col text-center fw-medium mb-1 ls-02em">
                Start&nbsp;14&nbsp;Days&nbsp;for&nbsp;Free
              </h4>
            </button>
          </div>
          <div
            class="fit-column-section z-2 z-index-70 ms-2 position-relative rounded-3 mb-80px w-282px pt-5 pe-5 ps-5 pb-6 d-inline-block"
            *ngIf="subscriptionPlanLength === 4">
            <h2 class="lh-3 f-col fw-bold ls-01em mb-0">Super Enterprise</h2>
            <div class="pt-2 pt-0-6 w-222">
              <h4 class="fw-normal col-grey font-outfit m-0">Customizable options for large-scale implementations</h4>
            </div>
            <h3 class="pt-3 f-col fw-medium lh-3 ls-02em mb-0">
              <span class="fs-40-lh-48-mobile ls-01em fw-semibold">$29</span> / per month
            </h3>
            <img src="/assets/images/dot/hr-custom.png" alt="hr" class="mt-5 mt-5-custom w-222">
            <div class="pt-4 ms-1">
              <img src="/assets/images/dot/blue-tick.png" alt="tick" class="blue-tick">
              <div class="align-middle d-inline-block">
                <h4 class="ms-2 f-col fw-normal mb-0">Plan Feature</h4></div>
              <br>
              <div class="h-10"></div>
              <img src="/assets/images/dot/blue-tick.png" alt="tick" class="blue-tick">
              <div class="align-middle d-inline-block">
                <h4 class="ms-2 fw-normal f-col mb-0">Plan Feature</h4></div>
              <br>
              <div class="h-10"></div>
              <img src="/assets/images/dot/blue-tick.png" alt="tick" class="blue-tick">
              <div class="align-middle d-inline-block">
                <h4 class="ms-2 fw-normal f-col mb-0">Plan Feature</h4></div>
              <br>
              <div class="h-10"></div>
              <img src="/assets/images/dot/blue-tick.png" alt="tick" class="blue-tick">
              <div class="align-middle d-inline-block">
                <h4 class="ms-2 fw-normal f-col mb-0">Plan Feature</h4></div>
            </div>
            <button type="submit"
                    class="start-14-days rounded-4 pt-1 w-222 bg-purple border-0 column-btn g-3 mt-6 mt-6-custom mt-3-1 d-flex align-items-center justify-content-center">
              <h4 class="f-col text-center fw-medium mb-1 ls-02em">
                Start&nbsp;14&nbsp;Days&nbsp;for&nbsp;Free
              </h4>
            </button>
          </div>
        </div>
      </div>
      <div class="background-fit-mobile position-relative rounded-3 w-1240 ms-0-mob ps-4 ps-4-mob">
        <img src="/assets/images/background/plan-background-2.png" alt="admin-background"
             class="sub-plan-2 z-1 rounded-3 custom-position-absolute" *ngIf="subscriptionPlanLength === 2">
        <img src="/assets/images/background/plan-background-3.png" alt="admin-background"
             class="sub-plan-3 rounded-3 custom-position-absolute" *ngIf="subscriptionPlanLength === 3">
        <img src="/assets/images/background/plan-background-4.png" alt="admin-background"
             class="sub-plan-4 z-1 rounded-3 custom-position-absolute" *ngIf="subscriptionPlanLength === 4">
        <div class="fit-column-section z-2 pt-5 pe-5 ps-5 pb-6 rounded-3 position-absolute right-10">
          <h2 class="lh-3 f-col fw-bold ls-01em">Basic</h2>
          <div class="pt-2 pt-0-6">
            <h4 class="fw-light col-grey font-outfit m-0">Ideal for small classrooms and individual educators</h4>
          </div>
          <h3 class="pt-3 f-col fw-medium lh-3 ls-02em mb-0"><span
            class="fs-40-lh-48-mobile ls-01em fw-semibold">$29</span> / per month
          </h3>
          <img src="/assets/images/dot/hr-custom.png" alt="hr" class="mt-5 mt-5-custom">
          <div class="pt-4 ms-1">
            <img src="/assets/images/dot/blue-tick.png" alt="tick" class="blue-tick">
            <div class="align-middle d-inline-block">
              <h4 class="ms-2 f-col fw-normal mb-0">Plan Feature</h4></div>
            <br>
            <div class="h-10"></div>
            <img src="/assets/images/dot/close.png" alt="close" class="close">
            <div class="align-middle d-inline-block">
              <h4 class="ms-2 fw-normal f-col mb-0">Plan Feature</h4></div>
            <br>
            <div class="h-10"></div>
            <img src="/assets/images/dot/close.png" alt="close" class="close">
            <div class="align-middle d-inline-block">
              <h4 class="ms-2 fw-normal f-col mb-0">Plan Feature</h4></div>
            <br>
            <div class="h-10"></div>
            <img src="/assets/images/dot/close.png" alt="close" class="close">
            <div class="align-middle d-inline-block">
              <h4 class="ms-2 fw-normal f-col mb-0">Plan Feature</h4></div>
          </div>
          <button type="submit"
                  class="start-14-days rounded-4 pt-1 bg-purple border-0 column-btn g-3 mt-6 mt-6-custom mt-3-1 d-flex align-items-center justify-content-center">
            <h4 class="f-col text-center fw-medium ls-02em mb-1">
              Start&nbsp;14&nbsp;Days&nbsp;for&nbsp;Free
            </h4>
          </button>
        </div>
        <div class="fit-column-section z-2 pt-5 mt-586 rounded-3 position-absolute d-inline-block br-2px-black">
          <h2 class="lh-3 f-col bg-spec ms-4 d-inline ps-3 pe-4 pt-1 pb-1 rounded-3 fw-bold ls-01em">Pro</h2>
          <div class="left-20px pe-5 ps-5 pb-6">
            <div class="pro-text pt-4">
              <h4 class="fw-light col-grey font-outfit m-0">Perfect for institutions with advanced needs</h4>
            </div>
            <h3 class="pt-3 f-col fw-medium lh-3 ls-02em mb-0"><span
              class="fs-40-lh-48-mobile ls-01em fw-semibold">$29</span> / per month
            </h3>
            <img src="/assets/images/dot/hr-custom.png" alt="hr" class="mt-5 mt-5-custom">
            <div class="pt-4 ms-1">
              <img src="/assets/images/dot/blue-tick.png" alt="tick" class="blue-tick">
              <div class="align-middle d-inline-block">
                <h4 class="ms-2 f-col fw-normal mb-0">Plan Feature</h4></div>
              <br>
              <div class="h-10"></div>
              <img src="/assets/images/dot/blue-tick.png" alt="tick" class="blue-tick">
              <div class="align-middle d-inline-block">
                <h4 class="ms-2 fw-normal f-col mb-0">Plan Feature</h4></div>
              <br>
              <div class="h-10"></div>
              <img src="/assets/images/dot/close.png" alt="close" class="close" *ngIf="subscriptionPlanLength !== 2">
              <img src="/assets/images/dot/blue-tick.png" alt="tick" class="blue-tick"
                   *ngIf="subscriptionPlanLength === 2">
              <div class="align-middle d-inline-block">
                <h4 class="ms-2 fw-normal f-col mb-0">Plan Feature</h4></div>
              <br>
              <div class="h-10"></div>
              <img src="/assets/images/dot/close.png" alt="close" class="close" *ngIf="subscriptionPlanLength !== 2">
              <img src="/assets/images/dot/blue-tick.png" alt="tick" class="blue-tick"
                   *ngIf="subscriptionPlanLength === 2">
              <div class="align-middle d-inline-block">
                <h4 class="ms-2 fw-normal f-col mb-0">Plan Feature</h4></div>
            </div>
            <button type="submit"
                    class="start-14-days rounded-4 pt-1 bg-purple border-0 column-btn g-3 mt-6 mt-6-custom mt-3-1 d-flex align-items-center justify-content-center">
              <h4 class="f-col text-center fw-medium ls-02em mb-1">
                Start&nbsp;14&nbsp;Days&nbsp;for&nbsp;Free
              </h4>
            </button>
          </div>
        </div>
        <div class="fit-column-enterprise z-2 pt-5 mt-1150 rounded-3 pe-5 ps-5 pb-6 position-absolute d-inline-block"
             *ngIf="subscriptionPlanLength === 4 || subscriptionPlanLength === 3">
          <h2 class="lh-3 f-col fw-bold ls-01em">Enterprise</h2>
          <div class="pt-2 pt-0-6">
            <h4 class="fw-light col-grey font-outfit m-0">Customizable options for large-scale implementations</h4>
          </div>
          <h3 class="pt-3 f-col fw-medium lh-3 ls-02em mb-0"><span
            class="fs-40-lh-48-mobile ls-01em fw-semibold">$29</span> / per month
          </h3>
          <img src="/assets/images/dot/hr-custom.png" alt="hr" class="mt-5 mt-5-custom">
          <div class="pt-4 ms-1">
            <img src="/assets/images/dot/blue-tick.png" alt="tick" class="blue-tick">
            <div class="align-middle d-inline-block">
              <h4 class="ms-2 f-col fw-normal mb-0">Plan Feature</h4></div>
            <br>
            <div class="h-10"></div>
            <img src="/assets/images/dot/blue-tick.png" alt="tick" class="blue-tick">
            <div class="align-middle d-inline-block">
              <h4 class="ms-2 fw-normal f-col mb-0">Plan Feature</h4></div>
            <br>
            <div class="h-10"></div>
            <img src="/assets/images/dot/blue-tick.png" alt="tick" class="blue-tick">
            <div class="align-middle d-inline-block">
              <h4 class="ms-2 fw-normal f-col mb-0">Plan Feature</h4></div>
            <br>
            <div class="h-10"></div>
            <img src="/assets/images/dot/blue-tick.png" alt="tick" class="blue-tick"
                 *ngIf="subscriptionPlanLength !== 4">
            <img src="/assets/images/dot/close.png" alt="close" class="close" *ngIf="subscriptionPlanLength === 4">
            <div class="align-middle d-inline-block">
              <h4 class="ms-2 fw-normal f-col mb-0">Plan Feature</h4></div>
          </div>
          <button type="submit"
                  class="start-14-days rounded-4 pt-1 bg-purple border-0 column-btn g-3 mt-6 mt-6-custom mt-3-1 d-flex align-items-center justify-content-center">
            <h4 class="f-col text-center fw-medium ls-02em mb-1">
              Start&nbsp;14&nbsp;Days&nbsp;for&nbsp;Free
            </h4>
          </button>
        </div>
        <div class="fit-column-section z-2 mt-1715 rounded-3 mb-80px w-282px pt-5 pe-5 ps-5 pb-6 position-absolute d-inline-block"
             *ngIf="subscriptionPlanLength === 4">
          <h2 class="lh-3 f-col fw-bold ls-01em">Super Enterprise</h2>
          <div class="pt-2 pt-0-6 w-222">
            <h4 class="fw-light col-grey font-outfit m-0">Customizable options for large-scale implementations</h4>
          </div>
          <h3 class="pt-3 f-col fw-medium lh-3 ls-02em mb-0"><span
            class="fs-40-lh-48-mobile ls-01em fw-semibold">$29</span> / per month
          </h3>
          <img src="/assets/images/dot/hr-custom.png" alt="hr" class="mt-5 mt-5-custom w-222">
          <div class="pt-4 ms-1">
            <img src="/assets/images/dot/blue-tick.png" alt="tick" class="blue-tick">
            <div class="align-middle d-inline-block">
              <h4 class="ms-2 f-col fw-normal mb-0">Plan Feature</h4></div>
            <br>
            <div class="h-10"></div>
            <img src="/assets/images/dot/blue-tick.png" alt="tick" class="blue-tick">
            <div class="align-middle d-inline-block">
              <h4 class="ms-2 fw-normal f-col mb-0">Plan Feature</h4></div>
            <br>
            <div class="h-10"></div>
            <img src="/assets/images/dot/blue-tick.png" alt="tick" class="blue-tick">
            <div class="align-middle d-inline-block">
              <h4 class="ms-2 fw-normal f-col mb-0">Plan Feature</h4></div>
            <br>
            <div class="h-10"></div>
            <img src="/assets/images/dot/blue-tick.png" alt="tick" class="blue-tick">
            <div class="align-middle d-inline-block">
              <h4 class="ms-2 fw-normal f-col mb-0">Plan Feature</h4></div>
          </div>
          <button type="submit"
                  class="start-14-days rounded-4 pt-1 w-222 bg-purple border-0 column-btn g-3 mt-6 mt-6-custom mt-3-1 d-flex align-items-center justify-content-center">
            <h4 class="f-col text-center fw-medium ls-02em mb-1">
              Start&nbsp;14&nbsp;Days&nbsp;for&nbsp;Free
            </h4>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    class="not-mobile-animation h-605 got-answers g-20 d-flex flex-column position-relative justify-content-center align-items-center">
    <img src="/assets/images/background/admin-background.png" alt="background"
         class="smaller-background h-605 w-100 w-100-mob position-absolute">
    <div class="got-questions mt-15 mt-8vw mt-12-mob d-flex">
      <h2 class="fw-bold f-col text-center ls-01em bg-spec lh-2 rounded-3">&nbsp;Got Questions?&nbsp;&nbsp;</h2>
    </div>
    <span class="fs-40-lh-48 f-col fw-semibold ls-01em">We've Got Answers!</span>
    <div class="container container-mob d-inline-flex align-items-center">
      <button (click)="prevSlide()" class="nav-arrow m-0 p-0 border-0 d-inline-block bg-transparent">
        <img src="/assets/images/arrow/start-arrow.png" alt="start-arrow" class="start-arrow"
             *ngIf="currentPosition === 0">
        <img src="/assets/images/arrow/start-blue.png" alt="start-arrow" class="start-arrow"
             *ngIf="currentPosition !== 0">
      </button>
      <div class="carousel-custom position-relative d-flex justify-content-center align-items-center mt-2 mt-05vw">
        <div class="start-14-days-trial p-7 rounded-3 br-2px-black position-absolute d-inline-block bg-white"
             *ngFor="let slide of slides; let i = index" [ngStyle]="getSlideStyles(i)">
          <h1 class="fw-medium-mob lh-3 fw-bold f-col ls-01em">{{ slide.title }}</h1>
          <h2 class="lh-2 col-grey font-outfit fw-light">{{ slide.text }}</h2>
        </div>
      </div>
      <button (click)="nextSlide()"
              class="nav-arrow m-0 p-0 justify-content-end container container-mob d-flex border-0 d-inline-block bg-transparent">
        <img src="/assets/images/arrow/end-arrow.png" alt="end-arrow" class="end-arrow"
             *ngIf="currentPosition !== 4">
        <img src="/assets/images/arrow/end-grey.png" alt="end-arrow" class="end-arrow"
             *ngIf="currentPosition === 4">
      </button>
    </div>
  </div>
  <div class="mobile-animation ms-1rem container container-mob d-flex justify-content-center">
    <img src="/assets/images/background/faq-background.png" alt="background"
         class="faq-background w-100 position-absolute">
    <div class="container container-mob position-absolute text-center mb-0 mt-9 ms-3-custom">
      <h3 class="fw-medium f-col ls-02em lh-lg w-160 bg-spec rounded-3 d-inline-block mb-0">&nbsp;Got Questions?&nbsp;</h3>
      <h1 class="lh-lg f-col fw-bold ls-01em mb-0">We've Got Answers!</h1>
    </div>
    <div class="mobile-animation container container-mob g-20 d-flex flex-column position-relative justify-content-center align-items-center d-inline-block">
      <div class="mt-16 container container-mob d-inline-flex justify-content-center align-items-center">
          <div class="m-0 carousel-custom container container-mob position-relative align-items-center mt-6 mt-30px">
            <div class="rounded-3 br-2px-black container container-mob position-absolute bg-white"
                *ngFor="let slide of slides; let i = index"
                [ngStyle]="getSlideStylesMobile(i)"
                [ngClass]="{
                  'start-free-trial ms-5 p-4': getSlideStylesMobile(i).opacity === 1,
                  'no-width': getSlideStylesMobile(i).opacity === 0
                }">
              <h2 class="fw-medium f-col ls-01em lh-base">{{ slide.title }}</h2>
              <h5 class="col-grey font-outfit ls-01em lh-base fw-normal">{{ slide.text }}</h5>
            </div>
          </div>
        <button (click)="prevSlide()" class="nav-arrow m-0 p-0 border-0 d-inline-block bg-transparent">
          <img src="/assets/images/arrow/start-arrow.png" alt="start-arrow" class="start-arrow ms-18"
               *ngIf="currentPosition === 0">
          <img src="/assets/images/arrow/start-blue.png" alt="start-arrow" class="start-arrow ms-18"
               *ngIf="currentPosition !== 0">
        </button>
        <button (click)="nextSlide()"
                class="nav-arrow m-0 p-0 border-0 d-inline-block bg-transparent">
          <img src="/assets/images/arrow/end-arrow.png" alt="end-arrow" class="end-arrow me-18 ms-5"
               *ngIf="currentPosition !== 4">
          <img src="/assets/images/arrow/end-grey.png" alt="end-arrow" class="end-arrow me-18 ms-5"
               *ngIf="currentPosition === 4">
        </button>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</main>
